import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerDetalleBimService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/DetalleBitacoraBIM",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerDetalleBimService };